"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* eslint-disable object-curly-newline, no-param-reassign */
var EventDispatcher = require('../utils/event-dispatcher');
var helpers = require('../utils/helpers');

// Create URL from supplied parameters
function createRecommendationsUrl(podId, parameters, options) {
  var apiKey = options.apiKey,
    version = options.version,
    serviceUrl = options.serviceUrl,
    sessionId = options.sessionId,
    userId = options.userId,
    clientId = options.clientId,
    segments = options.segments;
  var queryParams = {
    c: version
  };
  queryParams.key = apiKey;
  queryParams.i = clientId;
  queryParams.s = sessionId;

  // Validate pod identifier is provided
  if (!podId || typeof podId !== 'string') {
    throw new Error('podId is a required parameter of type string');
  }

  // Pull user segments from options
  if (segments && segments.length) {
    queryParams.us = segments;
  }

  // Pull user id from options and ensure string
  if (userId) {
    queryParams.ui = String(userId);
  }
  if (parameters) {
    var numResults = parameters.numResults,
      itemIds = parameters.itemIds,
      section = parameters.section,
      term = parameters.term,
      filters = parameters.filters,
      variationsMap = parameters.variationsMap,
      hiddenFields = parameters.hiddenFields,
      preFilterExpression = parameters.preFilterExpression,
      fmtOptions = parameters.fmtOptions;

    // Pull num results number from parameters
    if (!helpers.isNil(numResults)) {
      queryParams.num_results = numResults;
    }

    // Pull item ids from parameters
    if (itemIds) {
      queryParams.item_id = itemIds;
    }

    // Pull section from parameters
    if (section) {
      queryParams.section = section;
    }

    // Pull term from parameters
    if (term) {
      queryParams.term = term;
    }

    // Pull filters from parameters
    if (filters) {
      queryParams.filters = filters;
    }

    // Pull format options from parameters
    if (fmtOptions) {
      queryParams.fmt_options = fmtOptions;
    }

    // Pull hidden fields from parameters
    if (hiddenFields) {
      if (queryParams.fmt_options) {
        queryParams.fmt_options.hidden_fields = hiddenFields;
      } else {
        queryParams.fmt_options = {
          hidden_fields: hiddenFields
        };
      }
    }

    // Pull variations map from parameters
    if (variationsMap) {
      queryParams.variations_map = JSON.stringify(variationsMap);
    }

    // Pull pre_filter_expression from parameters
    if (preFilterExpression) {
      queryParams.pre_filter_expression = JSON.stringify(preFilterExpression);
    }
  }
  queryParams = helpers.cleanParams(queryParams);
  var queryString = helpers.stringify(queryParams);
  return "".concat(serviceUrl, "/recommendations/v1/pods/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(podId)), "?").concat(queryString);
}

/**
 * Interface to recommendations related API calls
 *
 * @module recommendations
 * @inner
 * @returns {object}
 */
var Recommendations = /*#__PURE__*/function () {
  function Recommendations(options) {
    (0, _classCallCheck2["default"])(this, Recommendations);
    this.options = options || {};
    this.eventDispatcher = new EventDispatcher(options.eventDispatcher);
  }

  /**
   * Get recommendations for supplied pod identifier
   *
   * @function getRecommendations
   * @description Retrieve recommendation results from Constructor.io API
   * @param {string} podId - Pod identifier
   * @param {object} [parameters] - Additional parameters to refine results
   * @param {string|array} [parameters.itemIds] - Item ID(s) to retrieve recommendations for (strategy specific)
   * @param {number} [parameters.numResults] - The number of results to return
   * @param {string} [parameters.section] - The section to return results from
   * @param {string} [parameters.term] - The term to use to refine results (strategy specific)
   * @param {object} [parameters.filters] - Key / value mapping of filters used to refine results
   * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
   * @param {object} [parameters.preFilterExpression] - Faceting expression to scope search results. Please refer to https://docs.constructor.com/reference/configuration-collections
   * @param {object} [parameters.fmtOptions] - An object containing options to format different aspects of the response. Please refer to https://docs.constructor.com/reference/v1-recommendations-get-pod-results for details
   * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
   * @param {object} [networkParameters] - Parameters relevant to the network request
   * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
   * @returns {Promise}
   * @see https://docs.constructor.com/reference/recommendations-recommendation-results
   * @example
   * constructorio.recommendations.getRecommendations('t-shirt-best-sellers', {
   *     numResults: 5,
   *     filters: {
   *         size: 'medium'
   *     },
   * });
   */
  return (0, _createClass2["default"])(Recommendations, [{
    key: "getRecommendations",
    value: function getRecommendations(podId, parameters) {
      var _this = this;
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var requestUrl;
      var fetch = this.options.fetch;
      var signal;
      if (typeof AbortController === 'function') {
        var controller = new AbortController();
        signal = controller && controller.signal;

        // Handle network timeout if specified
        helpers.applyNetworkTimeout(this.options, networkParameters, controller);
      }
      try {
        requestUrl = createRecommendationsUrl(podId, parameters, this.options);
      } catch (e) {
        return Promise.reject(e);
      }
      return fetch(requestUrl, {
        signal: signal
      }).then(helpers.convertResponseToJson).then(function (json) {
        if (json.response && json.response.results) {
          if (json.result_id) {
            // Append `result_id` to each result item
            json.response.results.forEach(function (result) {
              // eslint-disable-next-line no-param-reassign
              result.result_id = json.result_id;
            });
          }
          _this.eventDispatcher.queue('recommendations.getRecommendations.completed', json);
          return json;
        }
        throw new Error('getRecommendations response data is malformed');
      });
    }
  }]);
}();
module.exports = Recommendations;